// extracted by mini-css-extract-plugin
module.exports = {"Container":"MessagesPage_Container__3VhBT","Chat":"MessagesPage_Chat__1Hgdu","Dealer":"MessagesPage_Dealer__3wnAY","LatestMess":"MessagesPage_LatestMess__nB2km"};